module.exports = __webpack_public_path__ + "static/media/left-carousel-fadein.f2d76a64.png";